import React from 'react';

export const Footer: React.FC = () => {
  return (
    <footer className="bg-white text-stone-600 py-6 border-t border-orange-100 mt-auto">
      <div className="container mx-auto px-6 text-center">
        <p className="text-xs tracking-widest uppercase font-bold">
          Devine stone - All Rights Reserved &copy; {new Date().getFullYear()}
        </p>
      </div>
    </footer>
  );
};